import axios from '@/utils/axios'

// GET ALL
export const getFinanceUsers = (params = {}) => {
  return axios.get('/finance-users', { params })
}

// GET BY ID
export const getFinanceUserById = (id) => {
  return axios.get(`/finance-users/${id}`)
}

// DROPDOWN
export const getFinanceUserDropdown = () => {
  return axios.get('/finance-users/dropdown')
}

// CREATE
export const createFinanceUser = (data) => {
  return axios.post('/finance-users', data)
}

// UPDATE
export const updateFinanceUser = (id, data) => {
  return axios.put(`/finance-users/${id}`, data)
}

// DELETE
export const deleteFinanceUser = (id) => {
  return axios.delete(`/finance-users/${id}`)
}